// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ConfirmExtraPackets_buttonContainer__LfaYr","button":"ConfirmExtraPackets_button__PUQGu"};